/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiWindowNewDownRightIcon20Solid = forwardRef('UiWindowNewDownRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.5 13H4V8a3 3 0 0 1 3-3h8v-.5A2.5 2.5 0 0 0 12.5 2h-9A2.5 2.5 0 0 0 1 4.5v6A2.5 2.5 0 0 0 3.5 13Z" }),
        React.createElement("path", { d: "M7.5 17A2.5 2.5 0 0 1 5 14.5v-6A2.5 2.5 0 0 1 7.5 6h9A2.5 2.5 0 0 1 19 8.5v6a2.5 2.5 0 0 1-2.5 2.5h-9Z" })));
});
